import { render, staticRenderFns } from "./ScreeningStatusChips.vue?vue&type=template&id=43ee0f36"
import script from "./ScreeningStatusChips.vue?vue&type=script&lang=js"
export * from "./ScreeningStatusChips.vue?vue&type=script&lang=js"
import style0 from "./ScreeningStatusChips.vue?vue&type=style&index=0&id=43ee0f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports